(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/store.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/store.js');
"use strict";


const _RTK = RTK,
  configureStore = _RTK.configureStore;
const _svs$components$casin = svs.components.casino_react.casinoStore.endpoints,
  searchApi = _svs$components$casin.searchApi,
  favoritesApi = _svs$components$casin.favoritesApi;
const lastSearchedListenerMiddleware = svs.components.casino_react.casinoStore.middlewares.lastSearchedListenerMiddleware;
const lastSearchedReducer = svs.components.casino_react.casinoStore.reducers.lastSearchedReducer;
const store = configureStore({
  reducer: {
    [searchApi.reducerPath]: searchApi.reducer,
    [favoritesApi.reducerPath]: favoritesApi.reducer,
    lastSearched: lastSearchedReducer
  },
  middleware: getDefaultMiddleware => [lastSearchedListenerMiddleware.middleware, ...getDefaultMiddleware(), searchApi.middleware, favoritesApi.middleware]
});
setGlobal('svs.components.casino_react.casinoStore.store', store);

 })(window);